import { render, staticRenderFns } from "./ResumeContactInfo.vue?vue&type=template&id=3a8a78cf"
import script from "./ResumeContactInfo.vue?vue&type=script&lang=ts"
export * from "./ResumeContactInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports